import React from 'react';

export default () => (
    <svg width="34" height="32" viewBox="0 0 34 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.0002 25.7833L27.3002 32L24.5668 20.2833L33.6668 12.4L21.6835 11.3833L17.0002 0.333313L12.3168 11.3833L0.333496 12.4L9.4335 20.2833L6.70016 32L17.0002 25.7833Z" fill="#FFC632"/>
    </svg>
)